<template>
    <div class="row_center_center navbar">
        <backButton :back-route="backRoute"></backButton>
        <text class="navbar_title">{{ title }}</text>
    </div>
</template>
<script>
import backButton from "../backButton.vue";
export default {
    components: {
        backButton
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        backRoute: {
            type: [String, Object],
            default: null
        }
    }
}
</script>
<style lang="">

</style>
